import {
  FETCH_PRODUCT_TYPES_REQUEST,
  FETCH_PRODUCT_TYPES_SUCCESS,
  FETCH_PRODUCT_TYPES_FAILURE,
  ADD_PRODUCT_TYPE_REQUEST,
  ADD_PRODUCT_TYPE_SUCCESS,
  ADD_PRODUCT_TYPE_FAILURE,
  UPDATE_PRODUCT_TYPE_REQUEST,
  UPDATE_PRODUCT_TYPE_SUCCESS,
  UPDATE_PRODUCT_TYPE_FAILURE,
  DELETE_PRODUCT_TYPE_REQUEST,
  DELETE_PRODUCT_TYPE_SUCCESS,
  DELETE_PRODUCT_TYPE_FAILURE,
  SET_PRODUCT_TYPE_EDIT,
  CLEAR_PRODUCT_TYPE_EDIT,
} from '../../../../types/masters/styles/productType/productTypeTypes';
import {
  fetchProductTypes,
  addProductType,
  updateProductType,
  deleteProductType,
} from '../../../../../api/masters/styles/productType/productTypeApi';

export const fetchProductTypesAction = () => async (dispatch) => {
  dispatch({ type: FETCH_PRODUCT_TYPES_REQUEST });
  try {
    const data = await fetchProductTypes();
    dispatch({ type: FETCH_PRODUCT_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_PRODUCT_TYPES_FAILURE, payload: error.message });
  }
};

export const addProductTypeAction = (productType) => async (dispatch) => {
  dispatch({ type: ADD_PRODUCT_TYPE_REQUEST });
  try {
    await addProductType(productType);
    dispatch({ type: ADD_PRODUCT_TYPE_SUCCESS });
    dispatch(fetchProductTypesAction());
  } catch (error) {
    dispatch({ type: ADD_PRODUCT_TYPE_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateProductTypeAction = ({ id, productType }) => async (dispatch) => {
  dispatch({ type: UPDATE_PRODUCT_TYPE_REQUEST });
  try {
    const data = await updateProductType(id, productType);
    dispatch({ type: UPDATE_PRODUCT_TYPE_SUCCESS, payload: data });
    dispatch(fetchProductTypesAction());
  } catch (error) {
    dispatch({ type: UPDATE_PRODUCT_TYPE_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteProductTypeAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_PRODUCT_TYPE_REQUEST });
  try {
    await deleteProductType(id);
    dispatch({ type: DELETE_PRODUCT_TYPE_SUCCESS, payload: id });
    dispatch(fetchProductTypesAction());
  } catch (error) {
    dispatch({ type: DELETE_PRODUCT_TYPE_FAILURE, payload: error.message });
    throw error;
  }
};

export const setProductTypeEdit = (productType) => ({
  type: SET_PRODUCT_TYPE_EDIT,
  payload: productType,
});

export const clearProductTypeEdit = () => ({
  type: CLEAR_PRODUCT_TYPE_EDIT,
}); 